import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  TRIAL_ACCOUNT_STEP,
  TRIAL_PAYMENT_STEP,
} from 'screens/Trials/constants';

const VALID_TRIAL_STEPS = [TRIAL_ACCOUNT_STEP, TRIAL_PAYMENT_STEP];

const useTrialStep = () => {
  let { step } = useParams();

  const [stepCount, setStepCount] = useState(1);

  const isValidStep = useMemo(() => VALID_TRIAL_STEPS.includes(step), [step]);

  const displayStep = useMemo(() => {
    if (isValidStep) {
      return step;
    } else {
      return TRIAL_ACCOUNT_STEP;
    }
  }, [isValidStep, step]);

  useEffect(() => {
    switch (step) {
      case TRIAL_ACCOUNT_STEP:
        return setStepCount(1);
      case TRIAL_PAYMENT_STEP:
        return setStepCount(2);
      default:
        return setStepCount(1);
    }
  }, [step]);

  return { displayStep, isValidStep, stepCount };
};

export default useTrialStep;
